/* ================= TWS Solo publications — scroll sequence =================
   The design file drives this with CSS scroll-driven animations
   (`view-timeline-name:--solo` + `animation-timeline`). Support for that is
   still uneven, so instead of relying on it we scrub the very same @keyframes
   by hand: every animated element runs its animation paused, and we set a
   negative animation-delay proportional to progress. delay = -local * duration
   lands the animation on exactly the frame the timeline would have shown, so
   the keyframes and the timings from the design are preserved verbatim.

   Each element carries data-range="START END" (percentages of the section's
   scroll, matching the design's `animation-range: contain X% contain Y%`).

   Progress = how far the sticky stage has been scrolled through the section's
   own 520vh track. The section is pinned at EVERY width — mobile only collapses
   the two-column grid — so there is a single progress source.
   ========================================================================= */
(function () {
  'use strict';

  var DUR = 1; /* seconds — every scrubbed animation is declared as 1s in the CSS */

  function init(root) {
    var stage = root.querySelector('[data-solo-stage]');
    if (!stage) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-range]')).map(function (el) {
      var r = (el.getAttribute('data-range') || '0 100').split(/\s+/);
      return { el: el, s: parseFloat(r[0]) / 100, e: parseFloat(r[1]) / 100 };
    });
    if (!items.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clamp01(n) { return n < 0 ? 0 : (n > 1 ? 1 : n); }

    function progress() {
      var r = root.getBoundingClientRect();
      var dist = r.height - window.innerHeight;
      if (dist <= 0) return 0;
      return clamp01(-r.top / dist);
    }

    function apply() {
      var p = reduce ? 1 : progress();
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var span = it.e - it.s;
        var local = span > 0 ? (p - it.s) / span : 0;
        it.el.style.animationDelay = (-clamp01(local) * DUR) + 's';
      }
    }

    var queued = false;
    function run() { queued = false; try { apply(); } catch (e) {} }
    /* rAF is throttled while the tab is hidden, so pair it with a timeout and a
       slow interval — same belt-and-braces approach the design file used. */
    function onScroll() { if (queued) return; queued = true; requestAnimationFrame(run); setTimeout(run, 40); }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setInterval(run, 250);
    run();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-solo]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-solo]');
    if (r) init(r);
  });
})();
